import React from "react";
import "./GetMusicOnBeatsource.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnBeatsource = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select Beatsource distribution",
    "Release approved by stores",
    "Go live worldwide",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on Beatsource | DJ Streaming Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to Beatsource with FT Tunes and reach professional DJs worldwide. Get your tracks streamed in clubs, events, and live DJ performances."
        />

        <meta
          name="keywords"
          content="Beatsource distribution, DJ streaming distribution, upload music to Beatsource, DJ music distribution, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="beatsource-page">

        {/* HERO */}
        <section className="beatsource-hero">
          <Container>

            <img
              src="/Images/beatsource-logo.png"
              alt="Beatsource Distribution"
              className="beatsource-logo"
            />

            <h1>Get Your Music on Beatsource</h1>

            <p>
              Release your music on Beatsource and reach professional DJs,
              clubs, and live performers worldwide. Beatsource is the
              leading DJ streaming platform powered by Beatport,
              helping your tracks get discovered and played globally.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-beatsource"></div>
        </section>


        {/* SHOWCASE */}
        <section className="beatsource-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach DJs Everywhere</h2>

                <p>
                  Beatsource delivers your music directly to DJs performing
                  in clubs, festivals, radio shows, and live events.
                  Build your reputation inside the global DJ ecosystem.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-beatsource.png"
                  alt="Beatsource Platform"
                  className="beatsource-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="beatsource-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="beatsource-benefits">
          <Container>

            <h2 className="section-title">
              Built For Professional DJs
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>DJ Streaming</h5>
                  <p>Music played directly in DJ performances.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Club Exposure</h5>
                  <p>Reach clubs, events & live audiences worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Global Reach</h5>
                  <p>Access professional DJs across the globe.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Keep Ownership</h5>
                  <p>You retain 100% ownership of your music.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="beatsource-cta">
          <Container>

            <h2>Start Reaching DJs Worldwide</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnBeatsource;